// Shared layout dimensions — single source of truth for tab bar, FAB positioning, etc.
export const TAB_BAR_HEIGHT = 58
export const FAB_BOTTOM = TAB_BAR_HEIGHT + 4
